import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeroSearchForm from './HeroSearchForm';

// img
import HeroBottomImg from '../../images/hero-bottom.png';

export default function HeroSection3() {
    return (
        <>
            <section className='hero-section hero-section-three' id='home3'>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="hero-section-main-content">
                                <div className="hero-section-content text-center w-100 position-relative">
                                    <Row className='justify-content-center'>
                                        <Col lg={12} xl={10} xxl={8}>
                                            <h1 className='hero-title display-4 fw-semibold mb-0'>Explore the Home You’ve Always <span className='text-primary'>Dreamed</span> of Living In</h1>
                                            <p className='fw-medium fs-18 text-muted mt-4 pt-1 mb-50'>Discover a place where your dream home becomes a reality. With thoughtful design & unmatched comfort, we bring you spaces that perfectly fit your lifestyle and aspirations.</p>
                                        </Col>
                                    </Row>
                                    <Row className='justify-content-center'>
                                        <Col xl={8}>
                                            <ul className="nav nav-tabs justify-content-center hero-tab-filter" id="myTab" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link active" id="buy-tab" data-bs-toggle="tab" data-bs-target="#buy-tab-pane"
                                                        type="button" role="tab" aria-controls="buy-tab-pane" aria-selected="true">Buy</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="sell-tab" data-bs-toggle="tab" data-bs-target="#sell-tab-pane"
                                                        type="button" role="tab" aria-controls="sell-tab-pane" aria-selected="false">Sell</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="rent-tab" data-bs-toggle="tab" data-bs-target="#rent-tab-pane"
                                                        type="button" role="tab" aria-controls="rent-tab-pane" aria-selected="false">Rent</button>
                                                </li>
                                            </ul>
                                            <div className="tab-content hero-tab-content" id="myTabContent">
                                                <div className="tab-pane fade show active" id="buy-tab-pane" role="tabpanel" aria-labelledby="buy-tab" tabIndex="0">
                                                    <HeroSearchForm />
                                                </div>
                                                <div className="tab-pane fade" id="sell-tab-pane" role="tabpanel" aria-labelledby="sell-tab" tabIndex="0">
                                                    <HeroSearchForm />
                                                </div>
                                                <div className="tab-pane fade" id="rent-tab-pane" role="tabpanel" aria-labelledby="rent-tab" tabIndex="0">
                                                    <HeroSearchForm />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container fluid className='border-bottom hero3-bottom-img'>
                    <Row>
                        <Col md={12}>
                            <img src={HeroBottomImg} alt="" className='w-100' />
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}
